import { Table, Tag, Space, Button } from "antd";

import CheckIcon from "@/icons/CheckIcon";
import PencilIcon from "@/icons/PencilIcon";
import TrashIcon from "@/icons/TrashIcon";

import { STATUS_OPTIONS } from "@/constants/tasks";

const isSystemStatus = (item) => {
  if (!item) return false;
  return (
    item.is_default ||
    item.is_for_completion ||
    item.is_for_deletion ||
    item.is_for_cancellation ||
    item.is_for_draft ||
    item.is_for_acceptance
  );
};

const shouldDisableDelete = (item) => {
  return !item || isSystemStatus(item);
};

const getStatusIcon = (color) => {
  return STATUS_OPTIONS.find((option) => option.value === color)?.icon;
};

/**
 * Таблица статусов с возможностью редактирования и удаления
 * @param {Array} data - Массив статусов
 * @param {boolean} loading - Флаг загрузки
 * @param {Object} pagination - Настройки пагинации
 * @param {Function} onChange - Обработчик изменений таблицы
 * @param {Function} onEditItem - Обработчик редактирования статуса
 * @param {Function} onDeleteItem - Обработчик удаления статуса
 */
const StatusesTable = ({
  data,
  loading,
  pagination,
  onChange,
  onEditItem,
  onDeleteItem,
  scroll = { x: "100%" },
}) => {
  const columns = [
    {
      title: "№ п/п",
      dataIndex: "idx",
      key: "idx",
      width: 90,
      defaultSortOrder: "ascend",
      sorter: {
        compare: (a, b) => a.idx - b.idx,
        multiple: 1,
      },
    },
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 2,
      },
      render: (_, { name, color }) => (
        <Tag
          icon={getStatusIcon(color)}
          color={color}
          className="tag-with-icon-color"
        >
          {name}
        </Tag>
      ),
    },
    {
      title: "Основной",
      dataIndex: "is_default",
      key: "is_default",
      align: "center",
      render: (_, item) =>
        isSystemStatus(item) ? <CheckIcon style={{ fontSize: 16 }} /> : null,
    },
    {
      title: "",
      width: 90,
      fixed: "right",
      align: "center",
      key: "actions",
      render: (_, item) => (
        <Space>
          <Button
            type="link"
            icon={<PencilIcon />}
            onClick={() => onEditItem(item)}
            aria-label="Редактировать статус"
          />
          <Button
            type="link"
            icon={<TrashIcon />}
            disabled={shouldDisableDelete(item)}
            onClick={() => onDeleteItem(item)}
            aria-label="Удалить статус"
          />
        </Space>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
    />
  );
};

export default StatusesTable;
